/**
 * UI copy for container supplies from unit metadata.
 */

export function openActionLabel(supply) {
  if (supply?.labels?.open) return supply.labels.open;
  const unit = supply?.unit || 'unidade';
  return `Abrir ${unit}`;
}

export function depletedLabel(supply) {
  if (supply?.labels?.depleted) return supply.labels.depleted;
  const unit = supply?.unit || 'unidade';
  return `${capitalize(unit)} esgotado(a)`;
}

export function openCountLabel(supply, count) {
  const plural = supply?.unitPlural || supply?.unit || 'unidades';
  const n = Number(count) || 0;
  if (n === 1) {
    return `1 ${supply?.unit || 'unidade'} aberto(a)`;
  }
  return `${n} ${plural} abertos(as)`;
}

export function sealedCountLabel(supply, count) {
  const plural = supply?.unitPlural || supply?.unit || 'unidades';
  const n = Number(count) || 0;
  if (n === 1) {
    return `1 ${supply?.unit || 'unidade'} fechado(a)`;
  }
  return `${n} ${plural} fechados(as)`;
}

function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isPaidValue(paid) {
  return paid !== '' && paid != null && paid !== undefined;
}
